import React from 'react';

const HamburgerButton = ({ isOpen, onClick, style = {} }) => {
    return (
        <>
            <div 
                className={`hamburger-btn ${isOpen ? 'open' : ''}`}
                onClick={onClick}
                style={style}
            >
                <div className="hamburger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <style>{`
                .hamburger-btn { 
                    background: rgba(187, 173, 160, 0.8); 
                    backdrop-filter: blur(10px); 
                    border: 1px solid transparent; 
                    border-radius: 50%; 
                    width: 50px; 
                    height: 50px; 
                    display: flex; 
                    align-items: center; 
                    justify-content: center; 
                    cursor: pointer; 
                    transition: all 0.3s; 
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    z-index: 2000;
                }
                
                .hamburger-btn:hover { 
                    background: rgba(187, 173, 160, 1); 
                    transform: scale(1.05);
                }
                
                .hamburger-icon { 
                    width: 20px; 
                    height: 16px; 
                    position: relative; 
                }
                
                .hamburger-icon span { 
                    display: block; 
                    position: absolute; 
                    height: 2px; 
                    width: 100%; 
                    background: #fff; 
                    border-radius: 1px; 
                    opacity: 1; 
                    left: 0; 
                    transition: 0.25s ease-in-out; 
                }
                
                .hamburger-icon span:nth-child(1) { 
                    top: 0px; 
                }
                
                .hamburger-icon span:nth-child(2) { 
                    top: 7px; 
                }
                
                .hamburger-icon span:nth-child(3) { 
                    top: 14px; 
                }
                
                .hamburger-btn.open .hamburger-icon span:nth-child(1) { 
                    top: 7px; 
                    transform: rotate(135deg); 
                }
                
                .hamburger-btn.open .hamburger-icon span:nth-child(2) { 
                    opacity: 0; 
                    left: -20px; 
                }
                
                .hamburger-btn.open .hamburger-icon span:nth-child(3) { 
                    top: 7px; 
                    transform: rotate(-135deg); 
                }
                
                /* 響應式設計 */
                @media (max-width: 768px) {
                    .hamburger-btn {
                        top: 10px;
                        right: 10px;
                        width: 45px;
                        height: 45px;
                    }
                    
                    .hamburger-icon {
                        width: 18px;
                        height: 14px;
                    }
                    
                    .hamburger-icon span {
                        height: 2px;
                    }
                    
                    .hamburger-icon span:nth-child(2) {
                        top: 6px;
                    }
                    
                    .hamburger-icon span:nth-child(3) {
                        top: 12px;
                    }
                    
                    .hamburger-btn.open .hamburger-icon span:nth-child(1) {
                        top: 6px;
                    }
                    
                    .hamburger-btn.open .hamburger-icon span:nth-child(3) {
                        top: 6px;
                    }
                }
            `}</style>
        </>
    );
};

export default HamburgerButton;
